import { render, staticRenderFns } from "./bind-confirm-dialog.vue?vue&type=template&id=944f8c86&"
import script from "./bind-confirm-dialog.vue?vue&type=script&lang=js&"
export * from "./bind-confirm-dialog.vue?vue&type=script&lang=js&"
import style0 from "./bind-confirm-dialog.vue?vue&type=style&index=0&id=944f8c86&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports